// src/config/siteNav.js
// RouteChef's key pages, in one place: the top navigation, the phone menu, the footer and the site's
// structured data all read this list. Google builds the sitelinks under a "routechef" search mostly
// from links that repeat on every page, so keep this short, stable, and pointing at real pages.
import { FEATURES } from "./features";

const KASHMIR = (FEATURES.CURATED_SHOWCASE || []).find((c) => c.path && c.path.startsWith("/dmc/"))?.path
    || "/dmc/vertical-tours-kashmir/kashmir-srinagar-gulmarg-sonamarg-pahalgm";

/** Ready trips, shown under "Trips" */
export const TRIP_LINKS = [
    { to: KASHMIR, label: "Kashmir trip, 6 days", sub: "Srinagar, Gulmarg, Sonamarg, Pahalgam" },
    { to: "/hornbill-festival", label: "Hornbill Festival 2026", sub: "Nagaland, 1 to 10 Dec · from ₹999" },
    { to: "/dmc", label: "Local tour operators", sub: "Trips from DMCs across India" },
];

/** For tour operators, under "For Partners" */
export const PARTNER_LINKS = [
    { to: "/list-your-trip", label: "Trip page from your PDF", sub: "Upload an itinerary, it's live in minutes" },
    { to: "/partner-signup", label: "Become a partner", sub: "DMCs, tour operators and travel agents" },
];

/** The main links, in order. `menu` opens a dropdown: "trips" (TRIP_LINKS) or "partners" (PARTNER_LINKS). */
export const MAIN_LINKS = [
    { to: "/plan-a-trip", label: "Plan a Trip", desc: "Day by day plans with live travel and stays" },
    { key: "trips", label: "Trips", menu: "trips" },
    { to: "/how-to-reach", label: "How to Reach", desc: "Best routes to 280+ places" },
    { key: "partners", label: "For Partners", menu: "partners" },
];
export const MENU_LINKS = { trips: TRIP_LINKS, partners: PARTNER_LINKS };

/** Footer columns */
export const FOOTER_LINKS = [
    { title: "Plan", links: [
        { to: "/", label: "Train, flight and bus routes" },
        { to: "/plan-a-trip", label: "Plan a Trip" },
        { to: "/how-to-reach", label: "How to Reach guides" },
    ] },
    { title: "Trips", links: TRIP_LINKS.map(({ to, label }) => ({ to, label })) },
    { title: "Company", links: [
        { to: "/partner-signup", label: "Become a partner" },
        { to: "/list-your-trip", label: "Trip page from your PDF" },
        { to: "/contact", label: "Contact us" },
    ] },
];

/** Paths where the full navigation shows (content pages). Booking flows, chat and dashboards keep a quiet header. */
const NAV_PREFIXES = ["/plan-a-trip", "/trips", "/dmc", "/hornbill-festival", "/how-to-reach", "/contact", "/partner-signup", "/claim", "/list-your-trip", "/p"];
export const showsSiteNav = (path) => path === "/" || NAV_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));

/** Is a link the current page (or a parent of it)? */
export const isActive = (path, to) => (to === "/" ? path === "/" : path === to || path.startsWith(`${to}/`));
